import React from 'react';

const Footer = () => {
    return (
        <div>
              <div className='text-center footer py-5 lh-sm'>
                    <p>Address : 401F, 45-9, Yeonhui-ro 11ma-gil, Seodaemun-gu, Seoul, Republic of <br/> Korea
                    </p>
                    <p>Business license : 000-00-0000</p>
                    <p>Ceo Cpo :KIM HEESOO +82 10-000-0000</p>
                    <p>Company: DOJE</p>
                    <p>Contact: connect@doje.com</p>

                </div>
        </div>
    );
};

export default Footer;